export default [
  { title: 'Planning', route: 'planning', icon: 'CalendarIcon' },
  { title: 'Jeunes', route: 'youngs', icon: 'FileTextIcon' },
  { title: 'Répondeur', route: 'history', icon: 'PhoneIcon' },
  { title: 'Utilisateurs bloqués', route: 'blocklist', icon: 'MinusCircleIcon' },
  { title: 'Demandes d\'hébergement', route: 'accommodation-requests', icon: 'HomeIcon' },
  { title: 'Statistiques', route: 'statistics', icon: 'BarChart2Icon' },
  { title: 'Utilisateurs', route: 'utilisateurs', icon: 'UsersIcon' },
  { title: 'Mobile', route: 'mobile-settings', icon: 'SmartphoneIcon' },
]
